<!--  -->
<template>
  <Content :currentCode='code' />
</template>

<script>
import { reqArkChoose } from '@/api/home';
import Content from './content.vue';

export default {
  components: {
    Content,
  },
  data() {
    return {
      code: 0,
    };
  },
  computed: {},
  watch: {},
  methods: {
    async getRecentYear() {
      // 已登录--需定位最近选择的考级
      reqArkChoose().then((res) => {
        const { data } = res?.data;
        const {examTypeId} = data?.[0];
        this.code=examTypeId;
      }).catch(()=>{
         this.code=Number(this.$route.query.code);
      });
    },
  },
  created() {},
  mounted() {
    this.getRecentYear();
  },
};
</script>
